export var SIDE_PADDING = 30;
